import { OPERATION_TYPES, PAYMENT_CHANNELS } from './Payment'

// Models
import Model from './Model'
import Beneficiary from './Beneficiary'
import BankDetails from './BankDetails'
import PaymentOrderForexData from './PaymentOrderForexData'

class PaymentOrder extends Model {
  get type () {
    if (!this.sender.hasWallet) {
      return OPERATION_TYPES.TOPUP
    }

    if (!this.recipient.hasWallet) {
      return OPERATION_TYPES.WITHDRAWAL
    }

    return OPERATION_TYPES.INTERNAL
  }

  get isInternalType () {
    return this.type === OPERATION_TYPES.INTERNAL
  }

  get isTopupType () {
    return this.type === OPERATION_TYPES.TOPUP
  }

  get isWithdrawalType () {
    return this.type === OPERATION_TYPES.WITHDRAWAL
  }

  get isForexType () {
    return this.forex != null
  }

  get isCreated () {
    return this.status === PAYMENT_ORDER_STATUSES.CREATED
  }

  get isCanceled () {
    return this.status === PAYMENT_ORDER_STATUSES.CANCELED
  }

  get formatters () {
    return {
      sender: data => new Beneficiary(data),
      senderBank: data => new BankDetails(data),
      recipient: data => new Beneficiary(data),
      recipientBank: data => new BankDetails(data),
      forex: data => new PaymentOrderForexData(data)
    }
  }

  static get statusOptions () {
    return [
      { name: 'Created', value: PAYMENT_ORDER_STATUSES.CREATED },
      { name: 'Verified', value: PAYMENT_ORDER_STATUSES.VERIFIED },
      { name: 'Canceled', value: PAYMENT_ORDER_STATUSES.CANCELED }
    ]
  }

  static get channelOptions () {
    return [
      { name: 'BluOr Bank', value: PAYMENT_CHANNELS.BLUOR_BANK },
      { name: 'Bank of Lithuania', value: PAYMENT_CHANNELS.BANK_OF_LITHUANIA },
      { name: 'BilderAccount', value: PAYMENT_CHANNELS.BILDER_ACCOUNT },
      { name: 'Alfa Bank', value: PAYMENT_CHANNELS.ALFA_BANK },
      { name: 'ClearBank', value: PAYMENT_CHANNELS.CLEAR_BANK },
      { name: 'Privalgo', value: PAYMENT_CHANNELS.PRIVALGO },
      { name: 'Decta', value: PAYMENT_CHANNELS.DECTA },
      { name: 'TKB', value: PAYMENT_CHANNELS.TKB },
      { name: 'IFX', value: PAYMENT_CHANNELS.IFX },
      { name: 'Corpay', value: PAYMENT_CHANNELS.COP },
      { name: 'CZCB', value: PAYMENT_CHANNELS.CZCB },
      { name: 'iFAST', value: PAYMENT_CHANNELS.IFAST },
      { name: 'Mano Bank', value: PAYMENT_CHANNELS.MANO },
      { name: 'BluOr Bank US', value: PAYMENT_CHANNELS.BO_US },
      { name: 'Incore Bank AG', value: PAYMENT_CHANNELS.INCORE },
      { name: 'FV Bank', value: PAYMENT_CHANNELS.FV_BANK }
    ]
  }

  get schema () {
    return [
      'adminId',
      'amount',
      'automaticFee',
      'carriedOutBy',
      'channel',
      'comment',
      'unidentifiedRecipientComment',
      'createdAt',
      'createdBy',
      'currency',
      'feeAccount',
      'feeCurrency',
      'finishedAt',
      'id',
      'paymentId',
      'paymentStatus',
      'recipient',
      'referenceNumber',
      'sender',
      'settlementDate',
      'status',
      'urgency',
      'senderOnboarderName',
      'senderOnboarderGroup',
      'recipientOnboarderName',
      'recipientOnboarderGroup',
      'forex',
      'senderProfileName',
      'recipientProfileName',
      'bankVoCode'
    ]
  }
}

export const PAYMENT_ORDER_STATUSES = {
  CREATED: 'CREATED',
  VERIFIED: 'VERIFIED',
  CANCELED: 'CANCELED'
}

export default PaymentOrder
